import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { calculateGroIndexScore } from '../../utlis/calculations';
import lessThanIcon from "../../assets/images/lessThanIcon.svg";
import { hairGrowthUiData, hairThinningUiData } from './barGraphData';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';



const GroIndexGraph = ({ analysis, forType, base_analysis, mainType, isGlobal, graphType }) => {

	const { patient_id, analysis_id } = useParams();

	const [hairGrowth, setHairGrowth] = useState(null);
	const [baselineHairGrowth, setBaselineHairGrowth] = useState(null);
	const [hairThinningLevel, setHairThinningLevel] = useState(null)
	const [showTooltip, setShowTooltip] = useState(false);


	const toggleTooltipVisibility = () => {
		if (!hairGrowth && graphType === 'hair_growth') return;
		setShowTooltip(prev => !prev)
	}

	useEffect(() => {
		if (mainType === 'closeup') {
			setHairGrowth(analysis?.images?.closeup?.hair_growth?.[forType] || null);
			setHairThinningLevel(analysis?.images?.closeup?.hair_thinning?.[forType] || null)
		} else if (mainType === 'global') {
			setHairGrowth(analysis?.images?.global?.hair_growth || null);
			setHairThinningLevel(analysis?.images?.global?.hair_thinning || null)

		} else {
			setHairGrowth(null);
			setHairThinningLevel(null)
		}
	}, [analysis, mainType, forType]);

	useEffect(() => {
		if (mainType === 'closeup') {
			setBaselineHairGrowth(base_analysis?.images?.closeup?.hair_growth?.[forType] || null);
		} else if (mainType === 'global') {
			setBaselineHairGrowth(base_analysis?.images?.global?.hair_growth || null);
		} else {
			setBaselineHairGrowth(null);
		}
	}, [base_analysis, mainType, forType]);

	const getBackgroundColor = (thinning) => {
		if (['Severe Thinning', 'Advanced Thinning', 'Visible Thinning'].includes(thinning)) {
			return '#EF5656';
		}

		if (['Early Thinning', 'Moderate Thinning'].includes(thinning)) {
			return '#EF8679';
		}

		if (['Healthy'].includes(thinning)) {
			return '#1B9DBE';
		}
		return '#1B9DBE';
	}

	return (
		<div className='flex flex-col items-center h-full md:pr-0 xl:pr-12 justify-between sm:justify-start pb-1'>
			{hairThinningLevel || hairGrowth ? (
				<>
					<div className='relative flex justify-center'>
						{!isGlobal ? (
							<Link to={`/patient/${patient_id}/consult/${analysis_id}/closeup/${forType}/${graphType === 'hair_thinning' ? 'hair_growth' : 'hair_thinning'}`} className="absolute left-0" style={{transform: 'translate(-6px, 0)'}}>
								<button
									className="font-bold text-2xl focus:outline-none"
									onClick={function () {
										setShowTooltip(false)
									}}
								>
									<img src={lessThanIcon} className="h-8 w-8" />
								</button>
							</Link>
						) : ("")}


						<div className="text-center text-text-15  font-bold text-xxs xs:text-base xl:text-lg leading-4 xs:leading-5 tracking-wider opacity-80 w-2/3" style={{ fontFamily: 'Arial', letterSpacing: '1px' }}>
							{graphType === 'hair_thinning' ? "Thinning Hair Condition" : "Hair Growth Tracking"}
						</div>
					</div>

					<BarGraph hairThinningLevel={hairThinningLevel?.label} hairGrowthLevel={hairGrowth} graphType={graphType} showTooltip={showTooltip} toggleTooltipVisibility={toggleTooltipVisibility} />
				</>

			) : (
				""
			)}



			{/* <div className="text-center text-text-15  font-normal text-base leading-5 tracking-wider uppercase opacity-60 w-2/3" style={{ fontFamily: 'Arial', fontSize: '16px', lineHeight: '22px', letterSpacing: '1px' }}>
				({forType})
			</div> */}

			{/* <button className='mt-5' onClick={(e) => {setHairGrowthLevel(prev => prev + 1)}}>+</button>
			<button className='mt-5' onClick={(e) => {setHairGrowthLevel(prev => prev - 1)}}>-</button> */}


			{/* <div className='relative flex-grow flex justify-center items-end mt-6 w-2/3'>
				{
					mainType === 'closeup' && 
					<>
						{
							hairGrowth && analysis.id !== base_analysis.id && hairGrowth.percentage > 0 &&
							<div className='relative w-24 text-center py-6 mb-12' style={{
								backgroundColor: '#7CD8EF',
								height: `${mainType === 'closeup' ? `calc(${hairGrowth?.percentage > 150 ? 100 : (hairGrowth?.percentage < 0 ? 0 : (Math.ceil(hairGrowth?.percentage / 5) * 5) / 2)}% + 48px)` : `calc(${hairGrowth?.percentage > 100 ? 100 : (hairGrowth?.percentage < 0 ? 0 : Math.ceil(hairGrowth?.percentage / 10) * 10)}% - 48px)`}`,
								zIndex: 9999
							}}>
								<ShowScore hairGrowth={hairGrowth} mainType={mainType} />
								<div className='absolute text-center font-bold text-md leading-6 text-white letter-spacing-[0.36px] font-roboto top-2 w-24' style={{ right: '-142px', letterSpacing: '0.32px', opacity: 0.85}}>
									{hairGrowth?.label_desc}
									<br/> <span className='font-normal'>({dayjs.unix(analysis?.created_at).format("MM-DD-YY")})</span>
								</div>
							</div>
						}

						<div className="lines-container absolute bottom-0 left-0 w-24 text-center mb-12" style={{ height: 'calc(100% - 48px)', left: '50%', transform: 'translateX(-50%)' }}>
							{base_analysis.id !== analysis.id && Array.from({ length: hairGrowth?.percentage > 100 ? 5 : (hairGrowth?.percentage < 0 ? 0 : hairGrowth?.percentage/20) - 1 }).map((_, index) => (
								index !== 0	&& 
								<div
									key={index}
									className="line"
									style={{
										position: 'absolute',
										width: '100%',
										height: '1px',
										backgroundColor: 'rgba(0, 0, 0, 0.5)',
										bottom: `${index * 20}%`,
									}}
								>
								</div>
							))}
						</div>
					</>
				}
				
				<div className='absolute bottom-0 flex flex-col gap-2'>
					{
						baselineHairGrowth && 
						<div class="relative text-center font-bold text-white text-base leading-5 border-2 border-white py-3 px-4" style={{fontFamily: 'Arial', boxShadow: '0px 3px 6px #000000', backgroundColor: getBackgroundColor(baselineHairGrowth?.label)}}>
							{baselineHairGrowth?.percentage >= 0 && baselineHairGrowth?.label}
							{baselineHairGrowth?.percentage < 0 && <span>Invalid</span>}
							<div className='absolute top-1/2 transform -translate-y-1/2 -translate-x-3 text-center font-normal text-white text-opacity-85 text-base leading-5 tracking-wider font-roboto' style={{ right: '-100px', letterSpacing: '0.32px', opacity: 0.85}}>
								{dayjs.unix(base_analysis.created_at).format("MM-DD-YY")}
							</div>
						</div>
					}
				</div>
			</div> */}
		</div>
	)
}

const ShowScore = ({ hairGrowth, mainType }) => {
	const [show, setShow] = useState(false);

	return (
		<div onClick={() => { setShow(prev => !prev) }}>
			<p className="text-center font-bold text-black text-3xl leading-10 tracking-tighter" style={{ fontFamily: 'Arial', fontSize: '30px', lineHeight: '10px', letterSpacing: '-0.6px', opacity: '1' }}>
				{!show && calculateGroIndexScore(hairGrowth?.percentage, mainType)}
				{show && <span>{hairGrowth?.label_desc}</span>}
			</p>
		</div>
	)
}

const BarGraph = ({ graphType, hairThinningLevel, hairGrowthLevel, showTooltip, toggleTooltipVisibility }) => {

	// Index of hair thinning level item in hairThinningUiData object
	// Reason for finding index - We need the marker color data specific to this thinninglevel
	const thinningItemIndex = Object.values(hairThinningUiData).findIndex(level => level.markerKey === hairThinningLevel)

	// Growth item in hairGrowthUiData
	// Reason for finding item - We need to find marker position like (top: X%)
	const growthItem = hairGrowthUiData.markerPositions[Math.ceil(hairGrowthLevel?.gro_score)] || hairGrowthUiData.markerPositions.defaultFallback;

	const { tooltipHeading, tooltipDescription } = getTooltipText({groIndex: hairGrowthLevel?.gro_score, labelDesc: hairGrowthLevel?.label_desc})

	return (
		<div className='w-full grow mt-5 xl:mt-12 flex justify-center items-center'>
			<div className='flex flex-col justify-center items-center relative'>
				{graphType === 'hair_thinning' || (graphType !== 'hair_thinning' && graphType !== 'hair_growth') ? (
					Object.values(hairThinningUiData).map((item, index) => {
						return (
							<React.Fragment key={index}>
								{index > 0 ? (
									<div className='h-8 w-16 xs:h-11 xs:w-20 sm:h-8 sm:w-16 lg:h-9 lg:w-16 xl:h-11 xl:w-20 border-b' style={{ borderColor: "#90676426", backgroundColor: item.levelBgColor}} ></div>
								) : ("")}
								{thinningItemIndex === index ? (
									<>
										<div onClick={toggleTooltipVisibility} className={`${item.romanValue ? `w-24 xs:py-1 xs:w-28 sm:py-0 lg:py-1 sm:w-24 xl:w-28` : `px-4 xs:px-8 sm:px-5 lg:px-8 py-2 sm:py-1 lg:py-2 w-auto`} ${item.tooltipHeading ? `cursor-pointer` : ``} relative border-2 border-slate-200 rounded-md flex justify-center items-center z-10`} style={{backgroundColor: item.markerBgColor, boxShadow: "1px 2px 3px black, -1px 0px 3px black" }}>
											<span className={`text-text-9 ${item.romanValue ? `mr-1 text-base` : `font-semibold`}`} style={{ fontSize: '0.95rem' }}>{item.markerText}</span>
											<h1 className='text-text-9' style={{ fontSize: '1.80rem', lineHeight: '2rem' }}>{item.romanValue}</h1>
											{showTooltip && item.tooltipHeading ? (
												<div className="absolute top-10 flex flex-col items-center mb-6 group-hover:flex">
													<div className="w-6 h-6 bg-white" style={{ transform: "rotate(45deg)" }}></div>
													<div className="relative z-10 p-2 w-max bg-white text-center" style={{ transform: 'translate(0, -12px)' }}>
														<p className='text-xs xs:text-sm font-bold leading-none text-black mb-1 whitespace-nowrap'>{hairThinningLevel}</p>
														<p className='font-medium text-xs text-black whitespace-nowrap'>{item.tolltipDescription}</p>
													</div>

												</div>
											) : ("")}

										</div>
									</>

								) : ("")}
							</React.Fragment>
						)
					})
				) : (
					Object.values(hairGrowthUiData.growthLevelData).map((item, index) => {
						return (
							<React.Fragment key={index}>
								<div className='h-8 w-16 xs:h-11 xs:w-20 sm:h-8 sm:w-16 lg:h-9 lg:w-16 xl:h-11 xl:w-20 border-b' style={{ borderColor: "#90676426", backgroundColor: item.levelBgColor }}></div>
								<div className={`h-9 xs:h-10 lg:h-11 border-2 ${hairGrowthLevel ? 'w-24 sm:w-28 lg:w-32' : 'w-auto px-1 lg:px-3'} border-white rounded-lg flex justify-center items-center absolute z-50 ${tooltipHeading ? 'cursor-pointer' : ''}`} onClick={toggleTooltipVisibility} style={{backgroundColor: growthItem?.markerBgColor, boxShadow: "0px 2px 3px black, 0px -1px 1px #bfc5ca", top: growthItem?.position }}>
									{hairGrowthLevel?.label_desc === '0%' ? (
										<div className='h-1 w-8 bg-white'></div>
									) : (
										<span className={`text-text-9 text-bold ${hairGrowthLevel?.gro_score ? 'text-lg xs:text-2xl lg:text-3xl' : 'text-lg lg:text-xl'}`}>{hairGrowthLevel?.gro_score || growthItem.text}</span>
									)}
									{showTooltip && tooltipHeading ? (
										<div className="absolute top-11 flex flex-col items-center mb-6 group-hover:flex">
											<div className="w-6 h-6 bg-white" style={{ transform: "rotate(45deg)" }}></div>
											<div className="relative z-15 p-2 px-3 sm:px-5 w-max bg-white text-center" style={{ transform: 'translate(0, -12px)' }}>
												<p className='text-xs xs:text-sm font-bold leading-md text-black whitespace-nowrap'>{tooltipHeading}</p>
												<p className='font-normal text-xs text-black whitespace-nowrap'>{tooltipDescription && `(${tooltipDescription})`}</p>
											</div>

										</div>
									) : ("")}
								</div>
							</React.Fragment>
						)
					})
				)}

			</div>
		</div>
	)
}

function getTooltipText({groIndex, labelDesc}) {
	if (groIndex === 0) {
		return {
			tooltipHeading: "No further thinning",
			tooltipDescription: ""
		}
	} else if (groIndex >= 0.5 && groIndex < 2) {
		return {
			tooltipHeading: "Moderate improvement",
			tooltipDescription: labelDesc
		}
	} else if (groIndex >= 2 && groIndex <= 2.5) {
		return {
			tooltipHeading: "Good improvement",
			tooltipDescription: labelDesc
		}
	} else if (groIndex >= 3 && groIndex <= 3.5) {
		return {
			tooltipHeading: "Excellent improvement",
			tooltipDescription: labelDesc
		}
	} else if (groIndex >= 4) {
		return {
			tooltipHeading: "Exceptional improvement",
			tooltipDescription: labelDesc
		}
	} else {
		return {
			tooltipHeading: null,
			tooltipDescription: null
		}
	}

}

export default GroIndexGraph